import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  scheduleResults: null,
  scheduleError: null,
  isRouteScheduling: false,
  open: false,
  optimise: null,
  isRetryEnabled: true,
  isSaveEnabled: true,
  abortController: null,
  routeBeforeSchedule: [],
};

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    scheduleRouteStart(state) {
      state.open = true;
      state.isRouteScheduling = true;
    },
    scheduleRouteSetOptimise(state, action) {
      state.optimise = action.payload;
    },
    scheduleRouteComplete(state, action) {
      state.isRouteScheduling = false;
      state.scheduleResults = action.payload;
      state.scheduleError = null;
      state.abortController = null;
    },
    scheduleRouteError(state, action) {
      state.isRouteScheduling = false;
      state.scheduleError = action.payload.error;
      state.isSaveEnabled = action.payload.isSaveEnabled;
      state.isRetryEnabled = action.payload.isRetryEnabled;
    },
    scheduleRouteClose() {
      return initialState;
    },
    scheduleRouteSetAbortController(state, action) {
      state.abortController = action.payload;
    },
    scheduleRouteSetRoute(state, action) {
      state.routeBeforeSchedule = action.payload;
    },
  },
});

export const {
  scheduleRouteStart,
  scheduleRouteSetOptimise,
  scheduleRouteComplete,
  scheduleRouteError,
  scheduleRouteClose,
  scheduleRouteSetAbortController,
  scheduleRouteSetRoute,
} = scheduleSlice.actions;

export default scheduleSlice.reducer;
